import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import { OneRow, ThreeRow, TwoColumn, TwoRow } from "../../core/layouts";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import variables from "../../themes/base/styles/variables";

const viewUserBasicDetailsLayoutStyle = {
  twoColumnsStyle: {
    gap: variables.gapSmall,
    alignItems: variables.alignCenter,
  },
  twoRowStyle: {
    gap: variables.gapXS3,
    display: variables.dFlex,
    flexDirection: "column",
    justifyContent: variables.justifyCenter,
    marginTop: variables.marginXSmallest,
    marginBottom: variables.marginXSmallest,
  },
  nameEmailContainerStyle: {
    gap: variables.gapSmall,
    display: variables.dFlex,
    flexWrap: variables.flexWrap,
    width: variables.fullWidth,
    flex: 1,
  },
  twoColumnsStyleMobile: {
    gap: variables.gapSmall,
    alignItems: "start",
  },
  mobileAndRemarkStyle: {
    gap: variables.gapSmall,
    display: variables.dFlex,
    flexWrap: variables.flexWrap,
    width: variables.fullWidth,
    flex: 1,
  },
};

export default function ViewUserBasicDetailsLayout({
  leftAvatarSection,
  nameSection,
  emailSection,
  mobileSection,
  dividerSection,
  remarkSection,
}) {
  const responsive = useResponsive();
  return responsive?.isMd ? (
    <OneRow
      section={
        <TwoColumn
          style={viewUserBasicDetailsLayoutStyle.twoColumnsStyle}
          leftSection={leftAvatarSection}
          rightSection={
            <TwoRow
              style={viewUserBasicDetailsLayoutStyle.twoRowStyle}
              topSection={nameSection}
              bottomSection={
                <ThreeColumn
                  style={
                    viewUserBasicDetailsLayoutStyle.nameEmailContainerStyle
                  }
                  leftSection={emailSection}
                  middleSection={dividerSection}
                  rightSection={
                    <ThreeColumn
                      style={
                        viewUserBasicDetailsLayoutStyle.mobileAndRemarkStyle
                      }
                      leftSection={mobileSection}
                      middleSection={dividerSection}
                      rightSection={remarkSection}
                    />
                  }
                />
              }
            />
          }
        />
      }
    />
  ) : (
    <TwoRow
      style={viewUserBasicDetailsLayoutStyle.twoColumnsStyleMobile}
      topSection={leftAvatarSection}
      bottomSection={
        <ThreeRow
          style={viewUserBasicDetailsLayoutStyle.twoRowStyle}
          topSection={nameSection}
          middleSection={emailSection}
          bottomSection={
            <TwoRow
              style={viewUserBasicDetailsLayoutStyle.twoRowStyle}
              topSection={mobileSection}
              bottomSection={remarkSection}
            />
          }
        />
      }
    />
  );
}
